export const STOCK = 'stock'
export const TAG = 'tag'
export const NEWS = 'news'
export const INDUSTRY = 'industry_report'
